import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "../web/componnets/Home/Home";
import Nav from "../web/componnets/Navbar/Nav";
import Member from "../web/componnets/business_formating/LLC/LLC_Form/Members/Member";
import BusinessName from "../web/componnets/business_formating/LLC/LLC_Form/Business_name/BusinessName";
import BusinessLocation from "../web/componnets/business_formating/LLC/LLC_Form/Business_location/BusinessLocation";
import NameConfirm from "../web/componnets/business_formating/LLC/LLC_Form/Name_confirm/NameConfirm";
import BusinessType from "../web/componnets/business_formating/LLC/LLC_Form/Business_Type/BusinessType";
import LlcComplian from "../web/componnets/business_formating/LLC/LLC_Form/LLC_Complian/LlcComplian";
import RegisterAgent from "../web/componnets/business_formating/LLC/LLC_Form/RegisterAgent/RegisterAgent";
import Agreements from "../web/componnets/business_formating/LLC/LLC_Form/Agreements/Agreements";
import Report from "../web/componnets/business_formating/LLC/LLC_Form/Report/Report";
import BankDetails from "../web/componnets/business_formating/LLC/LLC_Form/BankDetails/BankDetails";
import ContactDetails from "../web/componnets/business_formating/LLC/LLC_Form/ContactDetails/ContactDetails";
import TotalPrice from "../web/componnets/business_formating/LLC/LLC_Form/TotalPrice/TotalPrice";
import { DataProvider } from "../DataContext/DataContext";
import Foundkit from "../web/componnets/business_formating/LLC/LLC_Form/Foundkit/Foundkit";
import CorpoHelp from "../web/componnets/business_formating/Corporation/corporationHelp/CorpoHelp";
import BusinessStart from "../web/componnets/business_formating/Corporation/Business_start/BusinessStart";
import LegalCompliant from "../web/componnets/business_formating/Corporation/legalComplaint/LegalCompliant";
import RegisterAgentCorpo from "../web/componnets/business_formating/Corporation/RegisterAgentCorpo/RegisterAgentCorpo";
import Business from "../web/componnets/Business/Business";
import LLC from "../web/componnets/Business/LLC";
import Tax from "../web/componnets/business_formating/Corporation/Tax/Tax";
import TotalComplaint from "../web/componnets/business_formating/Corporation/TotalComplaint/TotalComplaint";
import Package from "../web/componnets/business_formating/Corporation/Packages/Package";
import CorporationType from "../web/componnets/business_formating/Corporation/Corporation_type/CorporationType";
import MemberCorpo from "../web/componnets/business_formating/Corporation/memberCorpo/MemberCorpo";
import Thank from "../web/componnets/Thank";
import Payment from "../web/componnets/Stripe/payment";
import Login from "./../admin/components/Login/Login"
import Password from "../admin/components/Login/forgetpassword/Password";
import DashboardLayout from "./../admin/layout/DashboardLayout";
import RegisteredBusiLayout from "./../admin/layout/RegisteredBusiLayout";
import ApplicationDetailsLayout from "./../admin/layout/ApplicationDetailsLayout";
import PaymentLayout from "./../admin/layout/PaymentLayout";
import TransactionsList from "./../admin/layout/TransactionsList";
import AboutUs from "../web/componnets/about/AboutUs";
import Footer from "../web/footer/Footer";
import Services from "../web/componnets/Services/Services";
import Compliance from "../web/componnets/Services/Compliance";
import Licensing from "../web/componnets/Services/Licensing";
import CorpoFormation from "../web/componnets/Services/CorpoFormation";
import LlcFormation from "../web/componnets/Services/LlcFormation";
import ContactUs from "../web/componnets/contactUs/ContactUs";
import Resources from "../web/componnets/resources/Resources";
import Checklist from "../web/componnets/resources/Checklist";
import LlcVsCorpo from "../web/componnets/resources/LlcVsCorpo";
import ScorpVsCcorp from "../web/componnets/resources/ScorpVsCcorp";
import Ein from "../web/componnets/resources/Ein";
import Boi from "../web/componnets/resources/Boi";
import Checkout from "../web/componnets/Checkout/checkout";
import ProtectedRoute from "../admin/auth/Auth";
// import { NavigationProvider } from "../web/auth/NavigationProvider";
// import ProtectedPaymentRoute from "../web/auth/Auth"
// basename="oktobiz"
import Greeting from "../web/componnets/contactUs/greeting/Greeting";
// basename="better"

export default function Router() {
  return (
    <DataProvider>
      <BrowserRouter >
        <ScrollToTop />
        <App />
      </BrowserRouter>
    </DataProvider>
  );
}

function App() {
  const location = useLocation();
  const adminPathPrefixes = ["/home", "/table", "/transactions_list", "/details/", "/admin/payment"];
  const authOnlyPaths = ["/login", "/forgetpassword"];
  const isAdminView = adminPathPrefixes.some((path) => location.pathname === path || location.pathname.startsWith(path));
  const isAuthView = authOnlyPaths.includes(location.pathname);

  const showNav = !isAdminView;
  const showFooter = !isAdminView && !authOnlyPaths.includes(location.pathname) && location.pathname !== "/payment" && location.pathname !== "/checkout";

  useEffect(() => {
    if (isAdminView || isAuthView) {
      document.body.classList.add("admin-auth-view");
    } else {
      document.body.classList.remove("admin-auth-view");
    }
    return () => {
      document.body.classList.remove("admin-auth-view");
    };
  }, [isAdminView, isAuthView]);

  return (
    <div className="app-shell">
      {showNav && <Nav />}
      <main className="app-content">
        <Routes>
          <Route index element={<Home />} />
          <Route path="/business" element={<Business />} />
          <Route path="/services" element={<Services />}>
            <Route path="llc-formation" element={<LlcFormation />} />
            <Route path="corporation-formation" element={<CorpoFormation />} />
            <Route path="compliance" element={<Compliance />} />
            <Route path="licensing" element={<Licensing />} />
          </Route>
          <Route path="/resources" element={<Resources />}>
            <Route path="step-by-step-checklist" element={<Checklist />} />
            <Route path="llc-vs-corporation" element={<LlcVsCorpo />} />
            <Route path="scorp-vs-ccorp" element={<ScorpVsCcorp />} />
            <Route path="employer-id-number" element={<Ein />} />
            <Route path="beneficial-Ownership-info" element={<Boi />} />
          </Route>
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/greeting" element={<Greeting />} />
          <Route path="/business/LLC" element={<LLC />} />
          <Route path="/business/Corp" element={<CorporationType />} />
          <Route path="/business_name" element={<BusinessName />} />
          <Route path="/business_location" element={<BusinessLocation />} />
          <Route path="/Name_confirm" element={<NameConfirm />} />
          <Route path="/contact_details" element={<ContactDetails />} />
          <Route path="/business_type" element={<BusinessType />} />
          <Route path="/llc_complian" element={<LlcComplian />} />
          <Route path="/register_agent" element={<RegisterAgent />} />
          <Route path="/agreement" element={<Agreements />} />
          <Route path="/report" element={<Report />} />
          <Route path="/bank_details" element={<BankDetails />} />
          <Route path="/foundkit" element={<Foundkit />} />
          <Route path="/invoice" element={<TotalPrice />} />
          <Route path="/member_corpo" element={<MemberCorpo />} />
          <Route path="/corpo_help" element={<CorpoHelp />} />
          <Route path="/corp_question/:id" element={<BusinessStart />} />
          <Route path="/compliant" element={<LegalCompliant />} />
          <Route path="/register_agent_corpo" element={<RegisterAgentCorpo />} />
          <Route path="/member" element={<Member />} />
          <Route path="/tax" element={<Tax />} />
          <Route path="/total_Complaint" element={<TotalComplaint />} />
          <Route path="/package" element={<Package />} />
          <Route path="/confirm" element={<Thank />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgetpassword" element={<Password />} />

          {/* Admin routes, protected with ProtectedRoute where applicable */}
          <Route path="/home" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>} />
          <Route path="/table" element={<ProtectedRoute><RegisteredBusiLayout /></ProtectedRoute>} />
          <Route path="/admin/payment" element={<ProtectedRoute><PaymentLayout /></ProtectedRoute>} />
          <Route path="/details/:id" element={<ProtectedRoute><ApplicationDetailsLayout /></ProtectedRoute>} />
          <Route path="/transactions_list" element={<ProtectedRoute><TransactionsList /></ProtectedRoute>} />

          {/* Wildcard fallback to login or home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {showFooter && <Footer />}
    </div>
  );
}

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}